import { MoveIcon } from "lucide-react";
import { HelpContentContainer } from ".";
import { ModalHeader } from "@/components/Modal/ModalHeader";
import { AppText } from "@/components/Text/AppText";

interface HelpGuideLayoutProps {
    onClose: () => void;
}

export const HelpGuideLayout = ({ onClose }: HelpGuideLayoutProps) => {
    return (
        <div>
            <ModalHeader
                title="Changing the layout"
                onClose={onClose}
            />
            <HelpContentContainer>
                <AppText
                    variant="regular"
                    className="mb-2"
                >
                    To rearrange the layout positioning of the sections you have
                    included in your resume, click on the Rearrange button (
                    <MoveIcon
                        size={16}
                        className="mb-1 inline-block"
                    />
                    ) at the top of the screen.
                </AppText>
                <AppText
                    variant="regular"
                    className="mb-2"
                >
                    The rearrange modal will appear. You will then be able to to
                    drag and drop each section (excluding the Header section) to
                    suit your desired layout structure. Use the page layout
                    toggles to set your desired layout.
                </AppText>
            </HelpContentContainer>
        </div>
    );
};
